/* eslint-disable react-hooks/rules-of-hooks */
/* eslint no-use-before-define: "error"*/
import React, {
    useState, useContext} from 'react';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withViewModelService, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { ActivitiesService, SearchService } from 'gw-capability-gateway';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLBundleService } from 'ml-services-common-react';
import { MLModalService,MLTagManagerService } from 'ml-portals-services-react';

import mlNoteDetailPopupMsg from '../MLNoteDetailPopup/MLNoteDetailPopup.messages';
import mlNoteDetailPopupMetadata from '../MLNoteDetailPopup/MLNoteDetailPopup.metadata.json5';

import mlActivityDetailPopupMsg from '../MLActivityDetailPopup/MLActivityDetailPopup.messages';
import mlActivityDetailPopup from '../MLActivityDetailPopup/MLActivityDetailPopup';

import mlAddActivityPopup from '../MLAddActivityPopup/MLAddActivityPopup';
import mlAddActivityPopupMsg from '../MLAddActivityPopup/MLAddActivityPopup.messages'

import mlBundleQuestionPopup from '../MLBundleQuestionPopup/MLBundleQuestionPopup';
import mlBundleQuestionPopupMsg from '../MLBundleQuestionPopup/MLBundleQuestionPopup.messages.js';

import styles from '../ActivityReportsComponent/ActivityReportsComponent.module.scss';
import messages from './MLActivitiesComponent.messages';
import metadata from './MLActivitiesComponent.metadata.json5';


import { Button, Icon } from '@jutro/legacy/components';


const DISPLAY_LIMIT = 8
const MLActivitiesComponent = (props) => {
    const modalApi = useModal();
    const {
        accountActivities,
        accountNumber,
        policyNumber,
        onAddActivity,
        history
    } = props;

    const {
        showErrorModal,
        showProgressDialog
    } = MLModalService();


    const translator = useTranslator();

    const { authHeader } = useAuthentication();

    const { refreshData } = useDataRefresh();
    const [filteredJobs, updateFilteredJobs] = useState([]);
    const [expandRows, setExapandRows] = useState(false);
    const [showCollapsButton, setCollapseButton] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);

    const isOverdue = (dueDate) => {
        return moment(dueDate).isBefore(moment(), 'd');
    };

    const renderDueDateCell = (item) => {
        if (!item.dueDate) {
            return '-'
        }
        let dueDateClass = '';
        let showErrorIcon = false;
        if (isOverdue(item.dueDate)) {
            dueDateClass = 'error-text';
            showErrorIcon = true;
        }
        return (
            <span className={dueDateClass} style={{ verticalAlign: "middle", display: 'inline-flex' }}>
                {`Due ${moment(item.dueDate).format('MM/DD/YYYY')}`}
                {showErrorIcon ? <Icon icon="mi-error" /> : null} 
            </span>
        )
    };

    const renderInitiatorCell = (item) => {
        if (item.initiator_ML) {
            return item.initiator_ML;
        }
        return '-';
    };

    const renderPolicyCell = (item) => {
        const redirectQuote = () => {
            if (item.isBundled) {
                MLBundleService.updateBundleAndGotoAgentBundleCart(item.accountNumber, item.jobNumber, showProgressDialog, viewModelService, showErrorModal, history, authHeader);
            } else {
                const request = { searchParam: item.jobNumber };
                const searchPromise = SearchService.searchByJobNumber(request, authHeader);
                searchPromise.then((searchResult) => {
                    if (searchResult.searchAccountDetails[0]) {
                        const jobNumber = searchResult.searchAccountDetails[0].searchResultJobNumber;
                        const postalCode = searchResult.searchAccountDetails[0].searchResultJobPostalCode;
                        const isBookrollWithRateCapping = searchResult.searchAccountDetails[0].searchResultJobBookrollIndicator === 'With Rate Capping';
                        const isAlaska7Day = searchResult.searchAccountDetails[0].address.state === 'AK' && searchResult.searchAccountDetails[0].searchResultJobTerm === '7 days';

                        if (isBookrollWithRateCapping || isAlaska7Day) {
                            const modalTitle = 'agent.controllers.MLQuotesReportCtrl.Quote is not complete';
                            let modalMsg = '';
                            if (isBookrollWithRateCapping) {
                                modalMsg = translator(messages.contactBookManager);
                            } else {
                                modalMsg = translator(messages.quoteToCompleteInPC);
                            }
                            showErrorModal(modalTitle, modalMsg);
                            
                        } else {
                            const componentProps = {
                                title: mlBundleQuestionPopupMsg.savedQuote,
                                overrideProps: {
                                    accountNumber: searchResult.searchAccountDetails[0].accountNumber,
                                    quoteNumber: jobNumber,
                                    postalCode: postalCode,
                                    history,
                                    viewModelService,
                                    authHeader
                                },
                                CustomComponent: mlBundleQuestionPopup,
                                showFooterOnCustomComponent: false,
                                additionalPEStyle: 'customFooterModal'
                            };

                            modalApi.showModal(
                                <FormModalPopover {...componentProps} />
                            );
                        }
                    }
                }, () => {
                    console.error(new Error('Unable to retrieve submission'));
                });
            }
        };

        if (item.policyNumber || item.jobNumber) {
            if (item.jobNumber && !item.policyNumber) {
                return (
                    <Button onClick={redirectQuote} type="text">{item.jobNumber}</Button>
                )
            }
            if (item.policyNumber) {
                return (
                    <Link to={`/policies/${item.policyNumber}/summary`} className={styles.linkCellValue}>
                        {item.policyNumber}
                    </Link>
                )
            }
        }
        return translator(messages.account);
    };

    const updateActivities = (activities) => {
        updateFilteredJobs(activities);
        refreshData();
        onAddActivity();
    }

    const renderNoteCell = (item) => {
        if (!item.subject) {
            return '-';
        }
        const openActivityDetailModal = () => {
            MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Follow Up`);
            const openAddNoteDialog = (noteVM) => {
                const addNote = () => {
                    ActivitiesService.createNoteForActivity(item.publicID, noteVM.value, authHeader)
                        .then((newNote) => {
                            item.notes.push(newNote);
                            openActivityDetailModal();
                            MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Follow Up`);
                        });
                };
    
                const componentProps = {
                    title: mlNoteDetailPopupMsg.addNote,
                    uiProps: mlNoteDetailPopupMetadata.componentContent,
                    actionBtnLabel: _.upperCase(translator(mlNoteDetailPopupMsg.addNote)),
                    cancelBtnLabel: mlNoteDetailPopupMsg.cancelModal,
                    disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
                    viewModel: noteVM,
                    getOverrideProps: () => {
                        return {
                            policyAccountNumber: {
                                label: _.get(noteVM, 'value.policyNumber_ML') ? translator(mlNoteDetailPopupMsg.policyNumber) : translator(mlNoteDetailPopupMsg.accountNumber),
                                path: _.get(noteVM, 'value.policyNumber_ML') ? 'policyNumber_ML' : 'accountNumber'
                            }
                        }
                    },
                    onSaveAction: addNote,
                    buttonType: 'secondary'
                };
    
                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            }

            const componentProps = {
                title: mlActivityDetailPopupMsg.activityDetail,
                overrideProps: {
                    activity: item,
                    openAddNoteDialog,
                    filteredJobs,
                    updateActivities
                },
                CustomComponent: mlActivityDetailPopup,
                showFooterOnCustomComponent: false,
                additionalPEStyle: 'customFooterModal',
                viewModelService,
                authHeader
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        };

        return (
            <Button onClick={openActivityDetailModal} type="text">{item.subject}</Button>
        )
    };
    const renderassignedTOCell = (item) => {
        if (item.assignedTo) {
            return item.assignedTo;
        } 
        if (item.selectedQueue_ML) {
            return item.selectedQueue_ML.displayName;
        }
        return '-';
    };

    const setRowExpansion = () => {
        setExapandRows(true);
        setCollapseButton(true);

    }
    const setRowCollapse = () => {
        setExapandRows(false);
        setCollapseButton(false);
    }

    const getActivityRows = () => {
        if (expandRows) {
            return _.filter(accountActivities, (act) => act.status === 'open')
        }
        return _.filter(accountActivities, (act) => act.status === 'open').slice(0, DISPLAY_LIMIT)
    }
    const onClickAddFollowUp = () => {
        const componentProps = {
            title: mlAddActivityPopupMsg.activityDetail,
            overrideProps: {
                accountNumber: accountNumber,
                policyNumber: policyNumber,
                actionBtnLabel: _.upperCase(translator(mlAddActivityPopupMsg.activityDetail).replace('-',''))                           
            },
            CustomComponent: mlAddActivityPopup,
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader,
            onSaveAction: () => {
                onAddActivity();
                return true;
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const overrideProps = {
        followUpsReportTable: {
            visible: accountActivities && accountActivities.length > 0,
            data: getActivityRows(),
            noDataText: translator(messages.noFollowUpActivityFound),

        },
        expandButton: {
            visible: !expandRows && accountActivities.length > DISPLAY_LIMIT,
            onClick: setRowExpansion
        },
        collpaseButton: {
            visible: showCollapsButton,
            onClick: setRowCollapse
        },
        quotePolNumberColumn: {
            visible: accountNumber !== undefined
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            renderDueDateCell,
            renderInitiatorCell,
            renderPolicyCell,
            renderNoteCell,
            renderassignedTOCell,
            onClickAddFollowUp
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLActivitiesComponent.propTypes = {
    accountActivities: PropTypes.arrayOf(
        PropTypes.shape({})
    ).isRequired,
    accountNumber: PropTypes.string,
    policyNumber: PropTypes.string,
    onAddActivity: PropTypes.func.isRequired,
    history: PropTypes.shape({ push: PropTypes.func }).isRequired,
    isPcsIa: PropTypes.bool,

}

MLActivitiesComponent.defaultProps = {
    isPcsIa: undefined
}

export default withRouter(withViewModelService(MLActivitiesComponent));
